import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../config";
import { toast } from "react-toastify";

const IncidentTracking = ({ assetId, isWorkable }) => {
  const [formData, setFormData] = useState({
    subject: "",
    due_date: "",
    helpdesk_id: "",
    ticket_priority: "",
    incident_asset_id: assetId,
    location_id: "",
    description: "",
    incident_file: null,
  });

  const [helpdesk, setHelpdesk] = useState([]);
  const [priority, setPriority] = useState([]);
  const [locations, setLocations] = useState([]);
  const [ticketList, setTicketList] = useState([]);

  // 🚨 Prevent loading until assetId is available
  useEffect(() => {
    if (!assetId) return;
    loadFormData();
    loadTicketList();
  }, [assetId]);

  // ------------------------------------------
  // Load dropdown values
  // ------------------------------------------
  const loadFormData = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/asset/${assetId}/incident-form-data`
      );

      setHelpdesk(res.data.helpdesk_list);
      setPriority(res.data.priority_list);
      setLocations(res.data.location_list);
    } catch (err) {
      console.error("FORM ERROR:", err);
    }
  };

  // ------------------------------------------
  // Load Incident List
  // ------------------------------------------
  const loadTicketList = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/asset/${assetId}/incidents`);
      setTicketList(res.data);
    } catch (err) {
      console.error("LIST ERROR:", err);
    }
  };

  // ------------------------------------------
  // Submit Incident
  // ------------------------------------------
  const submitIncident = async (e) => {
    e.preventDefault();

    const fd = new FormData();
    Object.keys(formData).forEach((key) => {
      fd.append(key, formData[key]);
    });

    try {
      await axios.post(`${API_BASE_URL}/asset/incident/add`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success("Incident Created Successfully!");
      loadTicketList();
    } catch (err) {
      toast.error(err.response?.data?.message || "Error submitting incident");
    }
  };

  // ------------------------------------------
  // If asset not workable – block
  // ------------------------------------------
  if (!isWorkable || isWorkable === 0) {
    return (
      <p className="alert alert-warning">
        This asset is not workable. Change status first.
      </p>
    );
  }

  return (
    <div className="card p-3">
      <h5>Incident Tracking</h5>

      {/* ---------- INCIDENT FORM ---------- */}
      <form onSubmit={submitIncident}>
        <div className="row">

          <div className="col-md-6">
            {/* SUBJECT */}
            <label>Subject</label>
            <input
              type="text"
              className="form-control"
              value={formData.subject}
              onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
            />

            {/* DUE DATE */}
            <label className="mt-3">Due Date</label>
            <input
              type="date"
              className="form-control"
              value={formData.due_date}
              onChange={(e) => setFormData({ ...formData, due_date: e.target.value })}
            />

            {/* HELPDESK */}
            <label className="mt-3">Helpdesk</label>
            <select
              className="form-control"
              value={formData.helpdesk_id}
              onChange={(e) => setFormData({ ...formData, helpdesk_id: e.target.value })}
            >
              <option value="">Select</option>
              {helpdesk.map((h) => (
                <option key={h.department_id} value={h.department_id}>
                  {h.department_name}
                </option>
              ))}
            </select>

            {/* PRIORITY */}
            <label className="mt-3">Priority</label>
            <select
              className="form-control"
              value={formData.ticket_priority}
              onChange={(e) =>
                setFormData({ ...formData, ticket_priority: e.target.value })
              }
            >
              <option value="">Select</option>
              {priority.map((p) => (
                <option key={p.priority_id} value={p.priority_id}>
                  {p.name}
                </option>
              ))}
            </select>

            {/* LOCATION */}
            <label className="mt-3">Location</label>
            <select
              className="form-control"
              value={formData.location_id}
              onChange={(e) =>
                setFormData({ ...formData, location_id: e.target.value })
              }
            >
              <option value="">Select</option>
              {locations.map((l) => (
                <option key={l.loc_id} value={l.loc_id}>
                  {l.location_full}
                </option>
              ))}
            </select>
          </div>

          {/* RIGHT SIDE */}
          <div className="col-md-6">

            <label>Description</label>
            <textarea
              className="form-control"
              rows="5"
              value={formData.description}
              onChange={(e) =>
                setFormData({ ...formData, description: e.target.value })
              }
            ></textarea>

            <label className="mt-3">Upload File</label>
            <input
              type="file"
              className="form-control"
              onChange={(e) =>
                setFormData({ ...formData, incident_file: e.target.files[0] })
              }
            />
          </div>

        </div>

        <button className="btn btn-primary mt-3" type="submit">
          Submit Incident
        </button>
      </form>

      {/* ---------- INCIDENT LIST ---------- */}
      {/* <h5 className="mt-4">Incident List</h5> */}

      {/* <table className="table table-bordered">
        <thead>
          <tr>
            <th>Code</th>
            <th>Subject</th>
            <th>Priority</th>
            <th>Created</th>
            <th>Document</th>
          </tr>
        </thead>

        <tbody>
          {ticketList.map((t) => (
            <tr key={t.ticket_id}>
              <td>{t.ticket_code}</td>
              <td>{t.subject}</td>
              <td>{t.priority_name}</td>
              <td>{t.created_at}</td>
              <td>
                {t.issue_doc && (
                  <a
                    href={`${API_BASE_URL}/uploads/incident_document/${t.issue_doc}`}
                    target="_blank"
                  >
                    {t.issue_doc}
                  </a>
                )}
              </td>
            </tr>
          ))}
        </tbody>

      </table> */}
    </div>
  );
};

export default IncidentTracking;
